<script setup lang="ts">
import { onBeforeMount } from 'vue';
import router from '@/router';

import { CurrentKey, LoanType } from '@/helpers/const';
import { useCustomerQuoteProcess } from '@/helpers/useCustomerQuoteProcess';

import { CustomerQuoteProcessSteps, type CustomerQuoteProcessStepEnum } from '@/types';

import type { RouteParamsRaw } from 'vue-router';
import type { UtmMetricDto } from '@/api/backend/users/applications';

const props = defineProps<{
  utmMetrics: UtmMetricDto;
}>();

const { send, service, state, restart } = useCustomerQuoteProcess();

onBeforeMount(() => {
  // If it's a direct URL access, we store the utmMetrics.
  if (!history.state.back) {
    localStorage.setItem(CurrentKey, '');
    restart();

    const currentQuoteApp = state.value.context.loanApp;
    state.value.context.loanApp = {
      ...currentQuoteApp,
      userType: 'Primary',
      allowNoContractOfSale: true,
      utmMetrics: props.utmMetrics,
    };
  }

  send('READY');
});

service.onTransition((transition) => {
  if (transition.value !== 'gotoReady' && transition.value !== 'start') {
    const loanApp = transition.context.loanApp;
    const key = transition.value as CustomerQuoteProcessStepEnum;
    const name = CustomerQuoteProcessSteps[key].route;
    let params: RouteParamsRaw | undefined;
    if (name === 'quoteCompleted') {
      let finishType: string;
      if (loanApp.userType === 'Broker') {
        finishType = 'broker';
      } else if (loanApp.actionType === 'updateExisting') {
        if (state.value.context.from !== 'crm') {
          finishType = 'user_declaration';
        } else {
          finishType = 'income_expense';
        }
      } else {
        if (loanApp.loanType === LoanType.BRIDGING) {
          finishType = 'bridge_loan';
        } else if (loanApp.loanType === LoanType.SINGLE_SECURITY) {
          finishType = 'single_security';
        } else {
          finishType = 'equity_release';
        }
      }
      params = { finishType };
    }

    router.push({ name, params });
  }
});
</script>

<template>
  <div></div>
</template>
